import React, { PureComponent } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

export default class Index extends PureComponent {
  render() {
    return (
      <div className="cm-error-page">
        <Helmet title="Not Found" />
        <div className="cm-ep-box">
          <h1 className="font-size-36 mb-2">Page not found</h1>
          <p className="mb-3 text-black-50">The page is deprecated, deleted, or does not exist at all</p>
          <h1 className="font-size-80 mb-4 font-weight-bold">404 —</h1>
          <Link to="/" className="btn">
            &larr; Go back to the home page
          </Link>
        </div>
      </div>
    )
  }
}
